import { LandingTabsEnum } from './config';

export enum TabKey {
  Basics = 'basics',
  Media = 'media',
  Units = 'units',
  Promotions = 'promotions',
  Specifications = 'specifications',
  Summary = 'summary',
}

export enum ScreenKey {
  Welcome = 'welcome',
  ProjectName = 'project_name',
  Address = 'address',
  ProjectDescription = 'project_description',
  ProjectConstructors = 'project_constructors',
  ProjectGallery = 'project_gallery',
  DealType = 'deal_type',
  DealTypeResidential = 'deal_type_residential',
  ProjectFeatures = 'project_features',
  UnitStructure = 'unit_structure',
  UnitNamesAndFloors = 'unit_names_and_floors',
  UnitApartmentsSpecs = 'unit_apartments_specs',
  Promotions = 'promotions',
  Specifications = 'specifications',
  ProjectSummary = 'project_summary',
}
// aligned with ScreenKey and extras
export enum PreviewSections {
  // Navbar = 'navbar',
  TopGallery = 'top_gallery',
  ProjectDescription = 'project_description',
  InteractiveView = 'interactive_view',
  Promotions = 'promotions',
  Specifications = 'specifications',
  ProjectGallery = 'project_gallery',
  Address = 'address',
  UnitApartmentsSpecs = 'unit_apartments_specs',
  ProjectConstructors = 'project_constructors',
  OtherProjects = 'other_projects',
}

export type NavbarPage = {
  key: LandingTabsEnum;
  label: string;
  previewSectionsKey?: PreviewSections;
};

export enum NoteStatus {
  Approved = 'approved',
  Edited = 'edited',
  Rejected = 'rejected',
  Default = 'default',
}

export enum ScreenStatus {
  Default = 'default',
  Approved = 'approved',
  Edited = 'edited',
  Rejected = 'rejected',
}

export interface ProjectNoteCreator {
  id: number;
  name: string;
  email: string;
  avatar: string;
}

export interface ProjectNote {
  id: number;
  projectId: number;
  screenKey: ScreenKey;
  content: string;
  status: NoteStatus;
  createdBy: number;
  readBy: number[];
  createdAt: string;
  updatedAt: string;
  edited: boolean;
  creator: ProjectNoteCreator;
}
